import { useCallback, useEffect } from 'react'

type ScrollPosition = { x: number, y: number }

export const useScroll = (element: Window | HTMLElement | null, callback: (position: ScrollPosition) => void) => {
  const handler = useCallback((e: Event) => {
    const target = e.target instanceof Document ? e.target.documentElement : e.target as HTMLElement
    callback({
      x: target.scrollLeft,
      y: target.scrollTop,
    })
  }, [callback])

  useEffect(() => {
    element?.addEventListener('scroll', handler, { passive: true })
    return () => {
      element?.removeEventListener('scroll', handler)
    }
  }, [element, handler])
}
